var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgInstagramFull(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.133 0H4.867A4.876 4.876 0 000 4.867v8.247A4.88 4.88 0 004.867 18h8.247A4.88 4.88 0 0018 13.133V4.867A4.876 4.876 0 0013.133 0zm3.82 13.133a3.817 3.817 0 01-3.82 3.82H4.867a3.817 3.817 0 01-3.82-3.82V4.867a3.817 3.817 0 013.82-3.82h8.247a3.817 3.817 0 013.82 3.82v8.265zm-7.99-8.982A4.849 4.849 0 1013.812 9a4.844 4.844 0 00-4.849-4.849zm0 8.669A3.82 3.82 0 1112.784 9a3.829 3.829 0 01-3.821 3.82zM15.5 3.784a1.451 1.451 0 11-1.451-1.451A1.442 1.442 0 0115.5 3.784z",
    fill: "#fff"
  })));
}

export default __webpack_public_path__ + "static/media/instagram_full.819e0e77ed5dd8b0e9601072a1973892.svg";
export { SvgInstagramFull as ReactComponent };